// #region Dependencias
import styled from 'styled-components'
import { colors } from 'components/Library/theme'
// #endregion

// #region Estilos
const StyledCard = styled.div.attrs((props) => ({
  style: {
    borderRadius: `${props.borderradius || '1'}rem`
  }
}))`
  background-color: ${colors.white};
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.25);
  margin: auto auto;
  max-width: 1000px;
  text-align: ${({ center }) => (center ? 'center' : '')};
  transition: transform 0.3s;
`
// #endregion

/**
 * Componente que renderiza una tarjeta.
 * @class
 * @example <Buscador />
 * <Card>...</Card>
 *
 * @param {Object} props - Propiedades del componente.
 * @param {string} props.borderradius - Radio de las esquinas del componente.
 * @param {boolean} props.center - Valor que indica si el componente centrará su contenido.
 * @param {React.ReactNode} props.children - Contenido que será renderizado dentro del componente.
 */
const Card = ({ children, ...props }) => {
  return <StyledCard {...props}>{children}</StyledCard>
}

export default Card
